import { render, staticRenderFns } from "./AltaImpago.vue?vue&type=template&id=3c94665e&scoped=true&"
import script from "./AltaImpago.vue?vue&type=script&lang=js&"
export * from "./AltaImpago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94665e",
  null
  
)

export default component.exports